module.exports = __webpack_public_path__ + "fonts/3b1959a.ttf";